// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"8c75c331","457":"bff3a5e7","498":"cb5d3e18","703":"6a0c42d6","912":"c1d217f5"}[chunkId] + ".chunk.js";
};